import { ReactNode } from 'react';
import css from './Row.module.css';

export const Row = ({ start, end, customStyle }: TRowProps) => {
  return (
    <div className={`${css.root} ${customStyle || ''}`}>
      {start}
      {end}
    </div>
  );
};

export type TRowProps = {
  start: ReactNode;
  end?: ReactNode;
  customStyle?: string;
};
